export default __webpack_public_path__ + "static/media/012-geography.a01613fa.svg";